import React, { Component, useRef } from 'react';
import axios from 'axios';
import { Dialog, DialogActions, DialogContent, Button, TextField, Box, Typography } from '@mui/material';
import LINK from '../constants/LinkConstants';
import LoadProgress from '../common/LoadProgress.js';

export default function EmailAuthenticator({ emailAddr, setEmailVerified, verifyEmail, setVerifyEmail }) {
  const [step, setStep] = React.useState(0);
  const [emailErrorText, setEmailErrorText] = React.useState('');
  const [dataLoaded, setDataLoaded] = React.useState(true);
  const [sysErrorText, setSysErrorText] = React.useState('');
  const [verificationCode, setVerificationCode] = React.useState(['', '', '', '', '', '']);
  const digitRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

  const handleSend = () => {
    var objStep = { ...step };
    var objErrorText = { ...emailErrorText };

    if (step === 0) {
      if (emailErrorText.length > 0) {
        return;
      } else {
        doSend();
      }
    } else {
      doVerify();
    }
  };

  const handleCodeChange = (index, elem) => {
    let obj = { ...verificationCode };
    obj[index] = elem.target.value;
    if (elem.target.value.trim() === '' || isNaN(elem.target.value)) {
      obj[index] = '';
      setVerificationCode(obj)
      return;
    }

    console.log(obj);
    setVerificationCode(obj)
    if (obj[index] !== '' && index < 5)
      digitRefs[index + 1].current.focus();
  }

  const handleKeyDown = (index, e) => {
    // If backspace is pressed and the current field is empty, focus to the previous field
    if (e.key === 'Backspace' && verificationCode[index] && index > 0) {
      digitRefs[index - 1].current.focus();
    }
  }

  const handleVerificationCodePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');

    // check if pasted content is 6 digits
    if (/^\d{6}$/.test(pastedData)) {
      const newDigits = pastedData.split('');
      setVerificationCode(newDigits);

      // focus on last input
      digitRefs[5].current.focus()
    }
    console.log(pastedData);
  }

  const doSend = () => {
    // Send the form data.
    setDataLoaded(false);
    axios.post("EngagementTracker/sendVerificationCode", null, { params: { emailAddress: emailAddr } })
      .then((response) => {
        setSysErrorText('');
        setStep(1);
      }
      )
      .catch((error) => {
        setSysErrorText('Error sending E-Mail');
      })
      .finally(() => {
        setDataLoaded(true);
      });
  }

  const doVerify = () => {
    // Send the form data.
    setDataLoaded(false);
    var data = { emailAddress: emailAddr, verificationCode: Object.values(verificationCode).join('') };
    axios.post('EngagementTracker/verifyCode', data)
      .then((response) => {
        console.log(response.data);
        if (response.data === 'success') {
          setStep(2);
          setSysErrorText('');
        } else {
          setSysErrorText('6 digit code not matching. Please re-enter to validate again');
        }
        setDataLoaded(true);
      }
      )
      .catch((error) => {
        setSysErrorText('Error connecting to the server.');
        setDataLoaded(dataLoaded);
      }
      );
  }

  const handleContinue = () => {
    setEmailVerified(true);
    setVerifyEmail(false);
  }

  return (
    <div>
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        // disableEscapeKeyDown
        open={verifyEmail}
      >
        <form action="/" method="POST" onSubmit={(e) => { e.preventDefault(); handleSend() }}>
          <DialogContent>
            <Box sx={{ mt: 2 }}>
              {
                step === 1 &&
                <Typography variant='h5' align='center'>
                  Enter Verification Code
                </Typography>
              }
              <br />
              {step === 0 &&
                <div>
                  <span>
                    We will be sending 6 digit code for verification to <strong>{emailAddr}</strong>.
                  </span>
                </div>
              }

              {step === 1 &&
                <>
                  <Typography variant='body1' gutterBottom>
                    We've sent a 6-digit verification code to <strong>{emailAddr}</strong>.
                    <br />
                    Please enter the code here to proceed.
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, my: 3 }}
                    onPaste={handleVerificationCodePaste}
                  >
                    {[0, 1, 2, 3, 4, 5].map((index) => (
                      <>
                        <TextField
                          key={index}
                          inputRef={digitRefs[index]}
                          value={verificationCode[index]}
                          variant='outlined'
                          slotProps={{
                            htmlInput: { maxLength: 1 }
                          }}
                          onChange={(event) => handleCodeChange(index, event)}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          style={{ textAlign: 'center', fontSize: '28px', padding: '5px', }}
                          sx={{ width: '50px' }}
                        />
                      </>

                    ))}
                  </Box>
                  <LoadProgress open={!dataLoaded} />
                </>
              }
              {step === 2 &&
                <div style={{ maxHeight: '400px', justifyContent: 'left', alignItems: 'left' }}>
                  <span>E-Mail address verified. Please Continue..</span>
                </div>
              }
              {sysErrorText !== '' &&
                <span style={{ color: 'red', display: 'block', textAlign: 'right' }}>{sysErrorText}</span>
              }
            </Box>
          </DialogContent>

          <DialogActions>
            {step === 0 &&
              <>
                <Button color="secondary" disabled={(!dataLoaded)} onClick={() => setVerifyEmail(false)}>
                  Cancel
                </Button>
                <Button variant="contained" type="submit" color="primary" style={{ marginRight: 4 }} disabled={(!dataLoaded)}>
                  {dataLoaded === false ? 'Sending E-mail.. Please Wait' : 'Send Verification Code'}
                </Button>
              </>
            }
            {step === 1 &&
              <Button color="secondary" disabled={(!dataLoaded)} onClick={() => { setStep(0); setSysErrorText('') }}>
                Back
              </Button>
            }

            {step === 1 &&
              <div>
                <Button id="verify" variant="contained" type="submit" color="primary" style={{ marginRight: 4 }} disabled={
                  (Object.values(verificationCode).join('').length < 6) ||
                  !dataLoaded
                }>
                  {dataLoaded === false ? 'Verifying.. Please Wait' : 'Verify Code'}
                </Button>
              </div>
            }
            {step === 2 &&
              <div>
                <Button variant="contained" color="primary" style={{ marginRight: 4 }} onClick={handleContinue}>
                  Continue
                </Button>
              </div>
            }
          </DialogActions>
        </form>


      </Dialog>

    </div >


  );

}
